import React from 'react';
import PropTypes from 'prop-types';
import { IonAvatar } from '@ionic/react';
import './Avatar.css';

function Avatar({ src, firstName, lastName }) {
  const abbr = firstName.substr(0, 1) + lastName.substr(0, 1);
  return (
    <IonAvatar>
      {src ? (
        <img src={src} alt="Avatar" />
      ) : (
        <div className="avatar-wrapper">{abbr.toUpperCase()}</div>
      )}
    </IonAvatar>
  );
}

Avatar.propTypes = {
  src: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

export default Avatar;
